.aq{aspect-ratio:1/1;}